module.exports = __webpack_public_path__ + "static/blog-9-f4bdd7c3ed7f4f9c548278f8a9c5391a.png";